import { BaseWidget } from "./BaseWidget";

interface Props {
  value: number;
  compareValue: number;
  loading: boolean;
}

export const AMERWidget = ({ value, compareValue, loading }: Props) => {
  return (
    <BaseWidget
      title="aMER"
      value={value}
      compareValue={compareValue}
      loading={loading}
      downIsGood={false}
      subtitle="New customer rev / total spend"
      valueFormatter={(value) => value.toFixed(2)}
    />
  );
};
